import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

function Error404() {
  return (
      <Grid size={{xs:12}}>
        <Typography variant="h3">404 Not Found</Typography>
      </Grid>
  );
}

export default Error404;